var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextOutline20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.885 3c.502-.017.985.276 1.185.769l4.61 11.39a1.23 1.23 0 11-2.279.923l-.901-2.226H7.27l-.901 2.227a1.23 1.23 0 11-2.28-.923L8.7 3.769c.2-.493.684-.786 1.186-.768zm-1.65 8.47h3.299l-1.65-4.074-1.648 4.074z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Ljg4NDY5IDMuMDAwNzlDMTAuMzg2NyAyLjk4Mjc5IDEwLjg2OTcgMy4yNzU3OSAxMS4wNjk3IDMuNzY4NzlMMTUuNjc5NyAxNS4xNTk4QzE1LjkzMzcgMTUuNzg4OCAxNS42Mjk3IDE2LjUwNjggMTUuMDAxNyAxNi43NjA4QzE0LjM3MjcgMTcuMDE1OCAxMy42NTQ3IDE2LjcxMTggMTMuNDAwNyAxNi4wODI4TDEyLjQ5OTcgMTMuODU1OEw3LjI2OTY5IDEzLjg1NThMNi4zNjg2OSAxNi4wODI4QzYuMTE0NjkgMTYuNzExOCA1LjM5NjY5IDE3LjAxNTggNC43Njc2OSAxNi43NjA4QzQuMTM5NjkgMTYuNTA2OCAzLjgzNTY5IDE1Ljc4ODggNC4wODk2OSAxNS4xNTk4TDguNjk5NjkgMy43Njg3OEM4Ljg5OTY5IDMuMjc1NzggOS4zODI2OSAyLjk4Mjc5IDkuODg0NjkgMy4wMDA3OVpNOC4yMzU2OSAxMS40Njk4TDExLjUzMzcgMTEuNDY5OEw5Ljg4NDY5IDcuMzk1NzhMOC4yMzU2OSAxMS40Njk4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgTextOutline20 as ReactComponent };